import { Grid, Box, Typography } from '@mui/material';

import Form from 'components/Form';
import { IFormValues } from 'routes/Main/type';

import SectionTitle from '../../components/SectionTitle';

interface Props extends IFormValues {
  disabled?: boolean;
}

const checks = [
  {
    label: '식욕부진',
    key: 'no4.check01',
  },
  {
    label: '무기력',
    key: 'no4.check02',
  },
  {
    label: '수면장애',
    key: 'no4.check03',
  },
  {
    label: '입마름',
    key: 'no4.check04',
  },
  {
    label: '체중감소',
    key: 'no4.check05',
  },
  {
    label: '변비',
    key: 'no4.check06',
  },
  {
    label: '집중력감소',
    key: 'no4.check07',
  },
  {
    label: '어지러움',
    key: 'no4.check08',
  },
  {
    label: '졸림',
    key: 'no4.check09',
  },
  {
    label: '가려움증',
    key: 'no4.check10',
  },
  {
    label: '메스꺼움',
    key: 'no4.check11',
  },
  {
    label: '기침',
    key: 'no4.check12',
  },
];

const PainSymptoms = (props: Props) => {
  const { disabled, getValues, setValue } = props;

  return (
    <>
      <SectionTitle title="4. 통증에 영향을 미치는 동반 증상들" mb={3} mt={2} />
      <Typography
        sx={{
          fontSize: '12px',
          fontWeight: 500,
          marginBottom: '10px',
          marginLeft: '3px',
        }}
      >
        현재 다음의 증상들이 있다면 체크해주세요.(중복체크 가능)
      </Typography>
      <Box sx={{ width: '98%', margin: '10px auto 24px auto' }}>
        <Grid container xs={12}>
          {checks.map((v, i) => (
            <Grid item xs={2}>
              <Form.MuiCheckbox
                label={v.label}
                disabled={disabled}
                defaultValue={Boolean(getValues(v.key)) ? [v.label] : []}
                onChange={(_, checked) => {
                  setValue(v.key, checked);
                }}
              />
            </Grid>
          ))}
        </Grid>
      </Box>
    </>
  );
};

export default PainSymptoms;
